import React from 'react';
import TetrisBlock3D from './TetrisBlock3D';

const TetrisPiece3D = ({
  piece,
  isGhost = false,
  boardRows = 20,
  boardColumns = 10,
  BlockComponent = null
}) => {
  if (!piece || !piece.allCoordinates) {
    return null;
  }

  // Use themed block component if provided, otherwise default
  const Block = BlockComponent || TetrisBlock3D;

  return (
    <group>
      {piece.allCoordinates.map((coord, index) => {
        const [row, col] = coord;

        // Skip blocks above the visible board (row < 0)
        if (row < 0) return null;

        // Convert board coordinates to 3D world coordinates
        // Board is 10 columns wide, centered at x=0
        // Board is 20 rows tall, with row 0 at top
        const x = col - (boardColumns / 2) + 0.5;
        const y = (boardRows - row) - 0.5;
        const z = 0;

        return (
          <Block
            key={`piece-${index}`}
            position={[x, y, z]}
            colorClass={piece.colorClass}
            isGhost={isGhost}
            isActive={!isGhost}
            animate={!isGhost}
          />
        );
      })}
    </group>
  );
};

export default TetrisPiece3D;
